import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { Box, Button, Stack } from "@mui/material";
import type { FunctionComponent } from "react";

export interface NoSearchResultsProps {
  onFilterReset?: () => void;
}

export const NoSearchResults: FunctionComponent<NoSearchResultsProps> = ({
  onFilterReset,
}) => {
  return (
    <Stack pt={2} alignItems="center">
      <Box>
        <SearchSharpIcon color="action" sx={{ fontSize: 60 }} />
      </Box>
      <h3>No results found</h3>
      No results match your criteria. Remove some filters to show results.
      <Button onClick={onFilterReset} size="large">
        Reset all filters
      </Button>
    </Stack>
  );
};
